import {
  IRadioButton,
  IRadioButtonCollection,
  Properties
} from "@/utils/lomakkeet.ts";
import { ComponentEvent } from "@/graphHandling/graphTypes.ts";
import { equals, isNil, reject } from "ramda";
import { ComponentType } from "@/graphHandling/components/componentType.ts";
import { ReactElement } from "react";
import {
  getCurrentProps,
  getCurrentValue
} from "@/graphHandling/graphUtils.ts";
import {
  IRadioButtonProps,
  RadioButton
} from "@/graphHandling/components/radioButton.tsx";

/**
 * Undo-komponentin määrittely.
 * @param properties
 * @param modifications
 * @param functions
 * @returns
 */
export function defineRadioButton(
  properties: IRadioButtonProps,
  modifications?: Properties,
  functions?: { onChange: ComponentEvent }
): IRadioButton {
  return reject(isNil, {
    modifications,
    name: ComponentType.RADIO_BUTTON,
    onChange: functions?.onChange,
    properties
  }) as unknown as IRadioButton;
}

/**
 * Undo-komponentin renderöintifunktio.
 * @param radioButton
 * @param rBC Radio Button Collection.
 * @returns
 */
export function renderRadioButton(
  radioButton: IRadioButton,
  rBC: IRadioButtonCollection
): ReactElement | null {
  if (radioButton.name === ComponentType.RADIO_BUTTON) {
    let isChecked = !!radioButton.properties.isChecked;
    let radioStyleClasses: Array<string> = [];
    if (rBC) {
      isChecked =
        getCurrentValue("value", rBC) === radioButton.properties.value;
      const propsOfLupa = getCurrentProps(
        rBC,
        false,
        false
      ) as unknown as IRadioButtonProps;
      const currentRBCProps = getCurrentProps(rBC);
      if (!equals(currentRBCProps.value, propsOfLupa.value)) {
        if (equals(radioButton.properties.value, currentRBCProps.value)) {
          radioStyleClasses = ["text-[purple]"];
        } else if (equals(radioButton.properties.value, propsOfLupa.value)) {
          radioStyleClasses = ["text-[purple] line-through"];
        }
      }
    }

    const properties = getCurrentProps(
      radioButton
    ) as unknown as IRadioButtonProps;

    const propertiesWithDefaultValues = Object.assign(
      {},
      {
        isChecked: false
      },
      {
        ...properties,
        isChecked,
        styleClasses: radioStyleClasses //isRadioButtonModified ? ["text-[purple]"] : []
      }
    );
    const onChange = (
      rBC ? rBC.onChange : radioButton.onChange
    ) as ComponentEvent;

    if (onChange) {
      return (
        <RadioButton {...propertiesWithDefaultValues} onChange={onChange} />
      );
    }
  }

  return null;
}
